const detailsRequestDialogStyle = () => ({
	contentContainer: {
		margin: '16px 0 16px 72px',
		display: 'flex',
		flexDirection: 'column',
	},
	section: {
		margin: '0 0 16px 0',
	},
	row: {
		margin: '8px 0',
		display: 'flex',
		flexDirection: 'row',
	},
	columnLeft: {
		width: '124px',
	},
	columnRight: {
		margin: '0 24px',
		maxWidth: '50%',
	},
});

export default detailsRequestDialogStyle;
